import HID1 from "../../assets/work/HID/HID Mobile Access one.png";
import HID3 from "../../assets/work/HID/HID Mobile Access three.png";
import HID4 from "../../assets/work/HID/HID Mobile Access four.png";
import AQM1 from "../../assets/work/AQM/AdafruitAndRaspberryPi4.jpg";
import AQM4 from "../../assets/work/AQM/Shell logs 2023-07-21 at 12.12.18 p.m..png";
import AQM6 from "../../assets/work/AQM/AirQualityEmailAlert.png";
import AQM7 from "../../assets/work/AQM/temperature_humidity_data_2023-08-05T21_41_29+0100.png";
import AQM8 from "../../assets/work/AQM/24_hours_data_2023-08-05T21_41_29+0100.png";
import AQM9 from "../../assets/work/AQM/co2_data_2023-08-05T21_41_29+0100.png";
import AQM10 from "../../assets/work/AQM/ProjectBoard1.png";
import AQM11 from "../../assets/work/AQM/ProjectBoard2.png";
import AQM12 from "../../assets/work/AQM/AQMMobileApp1.jpg";
import AQM13 from "../../assets/work/AQM/AQMMobileApp2.jpg";
import AQM14 from "../../assets/work/AQM/Intelligent Indoor Air Quality and Ventilation Management in Confined Spaces using IoT - 22262621 - Vishnu Simha Dussa.pdf";
import AndroidFeat1 from "../../assets/work/AndroidFeatures/Project Structure1.png";
import AndroidFeat2 from "../../assets/work/AndroidFeatures/Project Structure2.png";
import AndroidFeat3 from "../../assets/work/AndroidFeatures/XMLBranchesFeatures.png";
import AndroidFeat4 from "../../assets/work/AndroidFeatures/jetpackComposeAppbranches.png";
import AndroidFeat5 from "../../assets/work/AndroidFeatures/xmlscreen1.png";
import AndroidFeat6 from "../../assets/work/AndroidFeatures/Xmlscreen2.png";
import OpenWeatherApp1 from "../../assets/work/WeatherDashboard/WeatherDashboard1.png";
import OpenWeatherApp2 from "../../assets/work/WeatherDashboard/WeatherDashboard2.png";
import SK1 from "../../assets/work/stockeeper/Manage_all_your_stock_in_one_place.png";
import SK2 from "../../assets/work/stockeeper/Add_stock_faster_with_smart_alerts.png";
import SK3 from "../../assets/work/stockeeper/Stay_ahead_with_smart_alerts.png";
import SK4 from "../../assets/work/stockeeper/Plan_your_shopping_before_you_buy.png";
import SK5 from "../../assets/work/stockeeper/Tick_off_items_as_you_shop.png";
import SK6 from "../../assets/work/stockeeper/Track_every_important_change.png";
import SK7 from "../../assets/work/stockeeper/Understand_your_stock_better.png";
import SK8 from "../../assets/work/stockeeper/Manage_shared_group_inventory.png";
import SK9 from "../../assets/work/stockeeper/Clean_light_and_dark_mode.png";
import VC1 from "../../assets/work/VigilCam/OnBoarding Screen1.png";
import VC2 from "../../assets/work/VigilCam/OnBoarding Screen2.png";
import VC3 from "../../assets/work/VigilCam/App Permissions.png";
import VC4 from "../../assets/work/VigilCam/Audio Tab Screen.png";
import VC5 from "../../assets/work/VigilCam/Info Dialog.png";
import VC6 from "../../assets/work/VigilCam/Control From Notification copy.png";
import VC7 from "../../assets/work/VigilCam/Control From Notification.png";
import VC8 from "../../assets/work/VigilCam/Recording Status Notification with Controls.png";
import VC9 from "../../assets/work/VigilCam/Video Recordings.png";
import VC10 from "../../assets/work/VigilCam/Video Recordings DT.png";
import VC11 from "../../assets/work/VigilCam/OnBoarding Screen1 Tablet.png";
import VC12 from "../../assets/work/VigilCam/App Permissions Tablet.png";
import VC13 from "../../assets/work/VigilCam/permissions required dialog tablet.png";
import VC14 from "../../assets/work/VigilCam/Dark Theme Tablet.png";
import VC15 from "../../assets/work/VigilCam/Audio Screen Tablet.png";
import CN1 from "../../assets/work/Cloudnine/Home.png";
import CN2 from "../../assets/work/Cloudnine/Home2.png";
import CN4 from "../../assets/work/Cloudnine/ServicesCorporate.png";
import CN5 from "../../assets/work/Cloudnine/CorporatePlanner.png";
import CN6 from "../../assets/work/Cloudnine/PlanningSpecialDayScreen.png";
import CN7 from "../../assets/work/Cloudnine/Prices.png";
import CN8 from "../../assets/work/Cloudnine/SafteyScreen.png";
import CN9 from "../../assets/work/Cloudnine/Enquiry.png";
import Res1 from "../../assets/work/Restaurant/Home.png";
import Res2 from "../../assets/work/Restaurant/About.png";
import Res4 from "../../assets/work/Restaurant/SignUp.png";
import Res5 from "../../assets/work/Restaurant/login.png";
import Res6 from "../../assets/work/Restaurant/Menu.png";
import Res7 from "../../assets/work/Restaurant/Specials.png";
import Res8 from "../../assets/work/Restaurant/Team.png";
import Res9 from "../../assets/work/Restaurant/CustomerReview.png";
import Res10 from "../../assets/work/Restaurant/Bottom Nav.png";
import Res11 from "../../assets/work/Restaurant/Cart.png";
import CSA1 from "../../assets/work/ClientServer/Server with 3 Clients Connected.png";
import CSA2 from "../../assets/work/ClientServer/Server with 2 Clients Connected.png";
import CSA3 from "../../assets/work/ClientServer/Client Disconnected with Server.png";
import CSA4 from "../../assets/work/ClientServer/Client Connected with Server.png";
import CSA5 from "../../assets/work/ClientServer/Server with 3 Clients Connected with Client windows.png";
import CSA6 from "../../assets/work/ClientServer/Server with 2 Clients Connected and Client windows.png";
import CSA7 from "../../assets/work/ClientServer/Server with 2 Clients Collision.png";
import CSA8 from "../../assets/work/ClientServer/Server with 3 Clients Connected with prev coordinates.png";
import CSA9 from "../../assets/work/ClientServer/Server with 3 Clients Connected and 2 Colliding.png";
import DAML1 from "../../assets/work/DAML/DAML1.png";
import DAML2 from "../../assets/work/DAML/DAML2.png";
import DAML3 from "../../assets/work/DAML/DAML3.png";
import DAML4 from "../../assets/work/DAML/DAML4.png";
import DAML5 from "../../assets/work/DAML/DAML5.png";
import DAML6 from "../../assets/work/DAML/DAML6.png";
import DAML7 from "../../assets/work/DAML/DAML7.png";
import DAML8 from "../../assets/work/DAML/DAML8.png";
import AndroidPlaceholder from "../../assets/work/Android.png";
import AndroidCardThumb from "../../assets/work/optimized/card-thumbnails/android-card-thumb.webp";
import CloudnineHome2CardThumb from "../../assets/work/optimized/card-thumbnails/cloudnine-home2-card-thumb.webp";
import CppPlaceholder from "../../assets/work/optimized/placeholders/cpp.webp";
import HID1CardThumb from "../../assets/work/optimized/card-thumbnails/hid-mobile-access-one-card-thumb.webp";
import HID3CardThumb from "../../assets/work/optimized/card-thumbnails/hid-mobile-access-three-card-thumb.webp";
import PythonPlaceholder from "../../assets/work/optimized/placeholders/python.webp";
import JavaPlaceholder from "../../assets/work/optimized/placeholders/java.webp";
import JavaSpringBootReactPlaceholder from "../../assets/work/JavaSpringBootReact.png";
import JavaSpringBootReactCardThumb from "../../assets/work/optimized/card-thumbnails/java-spring-boot-react-card-thumb.webp";
import ReactJavaScriptPlaceholder from "../../assets/work/ReactJavaScript.png";
import ReactJavaScriptCardThumb from "../../assets/work/optimized/card-thumbnails/react-javascript-card-thumb.webp";
import RestaurantAboutCardThumb from "../../assets/work/optimized/card-thumbnails/restaurant-about-card-thumb.webp";
import RestaurantHomeCardThumb from "../../assets/work/optimized/card-thumbnails/restaurant-home-card-thumb.webp";
import IoTPlaceholder from "../../assets/work/optimized/placeholders/iot.webp";
import NotesApp1 from "../../assets/work/NotesApp/NoteslandingScreen.png";
import NotesApp2 from "../../assets/work/NotesApp/NotesEmpty.png";
import NotesApp3 from "../../assets/work/NotesApp/NotesEmptyEditScreen.png";
import NotesApp4 from "../../assets/work/NotesApp/NotesEditScreenFilled.png";
import NotesApp5 from "../../assets/work/NotesApp/NotesListScreen.png";
import NotesApp6 from "../../assets/work/NotesApp/PasswordGeneratorScreen.png";
import ChatApp1 from "../../assets/work/fullstackChatApp/ChatSphereSignup.png";
import ChatApp2 from "../../assets/work/fullstackChatApp/ChatSphereLogin.png";
import ChatApp3 from "../../assets/work/fullstackChatApp/ChatSphereUpdatedDashboard.png";
import ChatApp4 from "../../assets/work/fullstackChatApp/ChatSpherePostAndComment.png";
import ChatApp5 from "../../assets/work/fullstackChatApp/ChatSphereDashboard.png";
import ChatApp6 from "../../assets/work/fullstackChatApp/ChatSphereFeedPostCategories.png";
import ChatApp7 from "../../assets/work/fullstackChatApp/ChatSphereQuestion.png";
import ChatApp8 from "../../assets/work/fullstackChatApp/ChatSphereCategories.png";
import ChatApp9 from "../../assets/work/fullstackChatApp/ChatSphereCategories2.png";

import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FiCpu,
  FiGithub,
  FiExternalLink,
  FiChevronLeft,
  FiChevronRight,
  FiServer,
  FiGlobe,
  FiDatabase,
  FiActivity,
  FiPlay,
  FiPause,
  FiX,
  FiZoomIn,
  FiMaximize2,
  FiMinimize2,
  FiShare2,
} from "react-icons/fi";

import {
  FaMobileAlt,
  FaCloud,
  FaCodeBranch,
  FaGooglePlay,
} from "react-icons/fa";
import { FaChartBar, FaBrain } from "react-icons/fa";
import { AiOutlineLineChart } from "react-icons/ai";
import { BsBarChartLine } from "react-icons/bs";
import { GoDatabase } from "react-icons/go";
import { GiArtificialIntelligence } from "react-icons/gi";

const DESCRIPTION_COLLAPSED_LINES = 6;
const PROJECT_MEDIA_PRELOAD_MARGIN = "300px 0px";
const PROJECT_CATEGORY_SLUGS = {
  All: "all",
  "Mobile Development": "mobile-development",
  IoT: "iot",
  "Full-Stack Development": "full-stack-development",
  "Software Systems": "software-systems",
  "Data Science / Machine Learning": "data-science-machine-learning",
};
const PROJECT_CATEGORY_BY_SLUG = Object.fromEntries(
  Object.entries(PROJECT_CATEGORY_SLUGS).map(([category, slug]) => [
    slug,
    category,
  ]),
);
const APP_ROUTE_SEGMENTS = new Set([
  "home",
  "projects",
  "blogs",
  "blog",
  "quiz",
  "contact",
  "resume-viewer",
]);
const SHARE_FEEDBACK_DURATION_MS = 2200;
const PROJECT_HIGHLIGHT_DURATION_MS = 5000;
const publicProjectAsset = (path) =>
  `${process.env.PUBLIC_URL}/projects/${path}`;
const optimizedProjectMedia = (srcPath, thumbnailPath) => ({
  src: publicProjectAsset(srcPath),
  thumbnail: publicProjectAsset(thumbnailPath),
});
const optimizedImportedMedia = (src, thumbnail) => ({
  src,
  thumbnail,
});
const getMediaSrc = (media) => (typeof media === "string" ? media : media.src);
const getMediaThumbnailSrc = (media) =>
  typeof media === "string" ? media : media.thumbnail || media.src;
const getProjectCategories = (project) =>
  Array.isArray(project.categories)
    ? project.categories
    : project.category
      ? [project.category]
      : [];
const getCategorySlug = (category) => PROJECT_CATEGORY_SLUGS[category];
const getCategoryFromSlug = (categorySlug) =>
  PROJECT_CATEGORY_BY_SLUG[categorySlug];
const getProjectPath = (project) =>
  `/projects/${getCategorySlug(project.category)}/${project.slug}`;
const getRouterBasePath = () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  if (!publicUrl) {
    const firstPathSegment = window.location.pathname
      .split("/")
      .filter(Boolean)[0];
    return firstPathSegment && !APP_ROUTE_SEGMENTS.has(firstPathSegment)
      ? `/${firstPathSegment}`
      : "";
  }

  try {
    return new URL(publicUrl, window.location.origin).pathname.replace(
      /\/$/,
      "",
    );
  } catch (error) {
    return publicUrl.replace(/\/$/, "");
  }
};
const getAbsoluteProjectUrl = (project) => {
  const basePath = getRouterBasePath();
  return `${window.location.origin}${basePath}${getProjectPath(project)}`;
};
const copyTextToClipboard = async (text) => {
  if (window.navigator?.clipboard?.writeText) {
    try {
      await window.navigator.clipboard.writeText(text);
      return;
    } catch {
      // Fall through to the textarea copy path when browser permissions block
      // the modern Clipboard API.
    }
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.top = "-9999px";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(textArea);
  }
};

const HID1Optimized = optimizedImportedMedia(HID1, HID1CardThumb);
const HID3Optimized = optimizedImportedMedia(HID3, HID3CardThumb);
const HID2Optimized = optimizedProjectMedia(
  "hid/hid-mobile-access-two.webp",
  "hid/hid-mobile-access-two-thumb.webp",
);
const HID5Optimized = optimizedProjectMedia(
  "hid/hid-mobile-access-five.webp",
  "hid/hid-mobile-access-five-thumb.webp",
);
const AQM2Optimized = optimizedProjectMedia(
  "aqm/aqm-hardware.webp",
  "aqm/aqm-hardware-thumb.webp",
);
const AQM3Optimized = optimizedProjectMedia(
  "aqm/aqm-hardware-2.webp",
  "aqm/aqm-hardware-2-thumb.webp",
);
const AQM5Optimized = optimizedProjectMedia(
  "aqm/window-open-data.webp",
  "aqm/window-open-data-thumb.webp",
);
const CN3Optimized = optimizedProjectMedia(
  "cloudnine/gallery.webp",
  "cloudnine/gallery-thumb.webp",
);
const Res3Optimized = optimizedProjectMedia(
  "restaurant/gallery.webp",
  "restaurant/gallery-thumb.webp",
);
const AndroidPlaceholderOptimized = optimizedImportedMedia(
  AndroidPlaceholder,
  AndroidCardThumb,
);
const CloudnineHome2Optimized = optimizedImportedMedia(
  CN2,
  CloudnineHome2CardThumb,
);
const JavaSpringBootReactPlaceholderOptimized = optimizedImportedMedia(
  JavaSpringBootReactPlaceholder,
  JavaSpringBootReactCardThumb,
);
const ReactJavaScriptPlaceholderOptimized = optimizedImportedMedia(
  ReactJavaScriptPlaceholder,
  ReactJavaScriptCardThumb,
);
const RestaurantHomeOptimized = optimizedImportedMedia(
  Res1,
  RestaurantHomeCardThumb,
);
const RestaurantAboutOptimized = optimizedImportedMedia(
  Res2,
  RestaurantAboutCardThumb,
);
const PiPulse1Optimized = optimizedProjectMedia(
  "pipulse/pipulse-ai-dashboard.webp",
  "pipulse/pipulse-ai-dashboard-thumb.webp",
);
const PiPulse2Optimized = optimizedProjectMedia(
  "pipulse/pipulse-dashboard-latest.webp",
  "pipulse/pipulse-dashboard-latest-thumb.webp",
);

const Projects = React.forwardRef((props, ref) => {
  const { categorySlug, projectSlug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const projects = useMemo(
    () => [
      {
        id: "hid-mobile-access",
        slug: "hid-mobile-access",
        name: "HID Mobile Access",
        description:
          "Contributed to the development and maintenance of HID Mobile Access, including app, SDK, and Android watch features. Worked in an agile team, handled sprint stories and customer issues using JIRA.",
        technologies: [
          "Kotlin",
          "Java",
          "Jetpack Compose",
          "XML",
          "Retrofit",
          "Room",
          "Hilt",
          "Firebase",
          "DataStore",
          "Coroutines",
          "Material Design",
          "Navigation",
        ],
        media: [
          HID1Optimized,
          HID2Optimized,
          HID3Optimized,
          HID4,
          HID5Optimized,
        ],
        category: "Mobile Development",
        links: [
          { type: "demo", url: "https://www.youtube.com/watch?v=Yfy0Y6YIJ7c" },
        ],
      },
      {
        id: "stockkeeper-android-app",
        slug: "stockkeeper-android-app",
        name: "StocKeeper — Android Inventory Management App",
        description:
          "A Kotlin and Jetpack Compose inventory management app for tracking groceries, medicines, household items, business stock, and shared group inventory. It includes Quick Add, low-stock and expiry alerts, shopping plans, reports, stock history, Firebase sync, and a clean offline-friendly user experience.",
        technologies: [
          "Kotlin",
          "Jetpack Compose",
          "Retrofit",
          "Firebase",
          "Room",
          "DataStore",
          "Material Design",
          "Real-time Database",
          "Hilt",
          "Coroutines",
          "PLAYSTORE RELEASED",
        ],
        media: [SK1, SK2, SK3, SK4, SK5, SK6, SK7, SK8, SK9],
        category: "Mobile Development",
        links: [
          { type: "github", url: "https://github.com/Vishnusimha/StocKeeper" },
          {
            type: "playstore",
            url: "https://play.google.com/store/apps/details?id=com.vishnu.stockeeper",
          },
        ],
      },
      {
        id: "vigilcam-android-app",
        slug: "vigilcam-android-app",
        name: "VigilCam - Background Video & Audio Recorder",
        description:
          "VigilCam is a specialized recording app that allows you to capture video and audio even when the screen is off or you are using other apps. Designed for reliability, it uses a background service to ensure long recordings stay stable and aren't interrupted by the system. Users can easily control recordings through notifications, manage files with fast thumbnail previews, and rely on the app even on low-storage devices. It is a secure, user-friendly tool built for seamless, discreet media capture.",
        technologies: [
          "Kotlin",
          "Jetpack Compose",
          "Foreground Services",
          "CameraX",
          "MediaRecorder",
          "Notifications API",
          "Material Design",
          "Coroutines",
          "Firebase Crashlytics",
          "PLAYSTORE RELEASED",
        ],
        media: [
          // AndroidPlaceholder,
          VC1,
          VC2,
          VC3,
          VC4,
          VC5,
          VC6,
          VC7,
          VC8,
          VC9,
          VC10,
          VC11,
          VC12,
          VC13,
          VC14,
          VC15,
        ],
        category: "Mobile Development",
        links: [
          { type: "github", url: "https://github.com/Vishnusimha/VigilCam" },
          {
            type: "playstore",
            url: "https://play.google.com/store/apps/details?id=com.vishnu.vigilcam",
          },
        ],
      },
      {
        id: "iot-air-quality-monitoring",
        slug: "iot-air-quality-monitoring",
        name: "IoT Indoor Air Quality Monitoring System",
        description:
          "Designed and implemented an IoT-based system to monitor CO2, humidity, and temperature using Raspberry Pi and Adafruit SCD40. Real-time data visualization and alerting through a custom Android app.",
        technologies: [
          "Python Flask",
          "Raspberry Pi",
          "Linux",
          "Edge Computing",
          "Cloud Storage",
          "Sensor Data Analysis",
        ],
        media: [
          IoTPlaceholder,
          PythonPlaceholder,
          AQM1,
          AQM2Optimized,
          AQM3Optimized,
          AQM4,
          AQM5Optimized,
          AQM6,
          AQM7,
          AQM8,
          AQM9,
          AQM10,
          AQM11,
          AQM12,
          AQM13,
        ],
        category: "IoT",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/IndoorAirQualityEE5003",
          },
          {
            type: "demo",
            url: "https://github.com/Vishnusimha/IndoorAirQualityEE5003/blob/main/README.md",
          },
          {
            type: "pdf",
            url: AQM14,
          },
        ],
      },
      {
        id: "social-chat-fullstack",
        slug: "social-chat-application",
        name: "Social Chat Application - Full-Stack (Android + Spring Boot)",
        description:
          "Built a scalable full-stack social chat app using Java (Spring Boot) microservices and React. Designed secure REST APIs for users, posts, and comments, with JWT authentication, resilient service communication, and MySQL data storage. Created a responsive React frontend for seamless user experience, routing all requests via an API gateway.",
        technologies: [
          "Java 17+",
          "Spring Boot",
          "Spring Cloud Gateway",
          "Eureka",
          "Spring Data JPA",
          "Resilience4j",
          "MySQL",
          "JWT",
          "Gradle",
          "Docker",
          "React (19+)",
          "JavaScript (ES6+)",
          "HTML5",
          "CSS3",
          "Android",
          "Kotlin",
          "Jetpack Compose",
          "Coroutines",
          "Retrofit",
          "Room",
        ],
        media: [
          JavaSpringBootReactPlaceholderOptimized,
          ChatApp1,
          ChatApp2,
          ChatApp3,
          ChatApp4,
          ChatApp5,
          ChatApp6,
          ChatApp7,
          ChatApp8,
          ChatApp9,
          AndroidPlaceholderOptimized,
        ],
        category: "Full-Stack Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/SecretMessage",
          },
          {
            type: "github",
            url: "https://github.com/Vishnusimha/chat-microservices",
          },
        ],
      },
      {
        id: "fullstack-restaurant-webapp",
        slug: "online-food-business",
        name: "Full-Stack Web Application - Online Business",
        description:
          "Developed a web application for an online takeaway restaurant business using Spring Boot and MySQL. The project features a responsive design, user authentication, and a dynamic menu. The backend is powered by Spring Boot, while the frontend is developed using HTML, CSS, and JavaScript.",
        technologies: [
          "Java",
          "Spring Boot",
          "MySQL",
          "Microservices",
          "Spring Security",
          "Spring Data JPA",
          "Spring MVC",
          "Rest API",
          "MVVM",
          "HTML/CSS",
          "JavaScript",
        ],
        media: [
          RestaurantHomeOptimized,
          RestaurantAboutOptimized,
          Res3Optimized,
          Res4,
          Res5,
          Res6,
          Res7,
          Res8,
          Res9,
          Res10,
          Res11,
        ],
        category: "Full-Stack Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/ee417-project",
          },
        ],
      },
      {
        id: "balloon-decor-website",
        slug: "balloon-decor-business-website",
        name: "Balloon Decor Business Website",
        description:
          "A complete online business website for a balloon decor venture. This full-stack project utilizes Spring Boot and MySQL for the server-side logic and database, complemented by a basic HTML/CSS frontend",
        technologies: [
          "Java",
          "Spring Boot",
          "MySQL",
          "Microservices",
          "MVVM",
          "HTML/CSS",
          "JavaScript",
          "Rest API",
        ],
        media: [
          CN1,
          CloudnineHome2Optimized,
          CN3Optimized,
          CN4,
          CN5,
          CN6,
          CN7,
          CN8,
          CN9,
        ],
        category: "Full-Stack Development",
        links: [
          { type: "github", url: "https://github.com/Vishnusimha/cloudnine" },
          { type: "github", url: "https://github.com/Vishnusimha/webapp" },
        ],
      },
      {
        id: "feature-rich-android-apps",
        slug: "feature-rich-android-applications",
        name: "Feature-Rich Android Applications",
        description:
          "Created modern Android apps using Kotlin with Jetpack Compose and XML views, integrating technologies like Retrofit, Room, Firebase, Hilt, and Coroutines to deliver scalable, maintainable codebases.",
        technologies: [
          "Kotlin",
          "Jetpack Compose",
          "XML",
          "Retrofit",
          "Room",
          "Firebase",
          "Hilt",
          "Coroutines",
          "OkHttp",
          "DataStore",
          "Material Design",
          "SonarQube Integration",
        ],
        media: [
          AndroidPlaceholderOptimized,
          AndroidFeat1,
          AndroidFeat2,
          AndroidFeat3,
          AndroidFeat4,
          AndroidFeat5,
          AndroidFeat6,
        ],
        category: "Mobile Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/FeaturesCompose",
          },
          {
            type: "github",
            url: "https://github.com/Vishnusimha/FeaturesXml",
          },
        ],
      },
      {
        id: "notes-android-app",
        slug: "notes-android-app",
        name: "Notes - Android App",
        description:
          "Developed a note-taking application for Android using Kotlin and Jetpack Compose. Implemented features like user authentication, note creation, editing, and deletion. Utilized Room Database for local data storage and ensured a smooth user experience with a responsive UI.",
        technologies: ["Kotlin", "Android", "Jetpack Compose", "Room Database"],
        media: [
          AndroidPlaceholderOptimized,
          NotesApp1,
          NotesApp2,
          NotesApp3,
          NotesApp4,
          NotesApp5,
          NotesApp6,
        ],
        category: "Mobile Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/Notes",
          },
        ],
      },
      {
        id: "personal-portfolio-website",
        slug: "personal-portfolio-website",
        name: "Personal Portfolio Website",
        description:
          "A modern, responsive portfolio website built with React showcasing professional experience, projects, and technical skills. Features interactive project galleries, a GitHub-flavored markdown blog system with syntax highlighting, downloadable resume, contact form integration, and dark/light theme toggle. Renders markdown as React components with sanitized raw HTML support for README-style content.",
        technologies: [
          "React",
          "React Router",
          "React Icons",
          "React Typed",
          "Framer Motion",
          "Lottie React",
          "React Markdown",
          "Remark GFM",
          "Rehype Raw",
          "Rehype Sanitize",
          "Rehype Highlight",
          "Highlight.js",
          "EmailJS",
          "Formspree",
          "Tailwind CSS",
          "PostCSS",
          "GitHub Pages",
          "Vercel",
        ],
        media: [ReactJavaScriptPlaceholderOptimized],
        category: "Full-Stack Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/vishnuportfolio",
          },
          {
            type: "demo",
            url: "https://vishnusimha.github.io/vishnuportfolio",
          },
          {
            type: "demo",
            url: "https://vishnusimha.github.io/vishnuportfolio/home",
          },
        ],
      },
      {
        id: "weather-dashboard-react",
        slug: "weather-dashboard",
        name: "Weather Dashboard – React Project",
        description:
          "Developed a responsive weather dashboard using React and OpenWeatherMap API. Features include data fetching, error handling, and real-time UI updates. Deployed via GitHub Pages.",
        technologies: ["React", "JavaScript", "REST API", "CSS"],
        media: [OpenWeatherApp1, OpenWeatherApp2],
        category: "Full-Stack Development",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/react-weather-dashboard",
          },
          {
            type: "demo",
            url: "https://vishnusimha.github.io/react-weather-dashboard/",
          },
        ],
      },
      {
        id: "java-client-server-robot-simulation",
        slug: "java-client-server-robot-simulation",
        name: "Java Client-Server Architecture for Multi-Agent Robot Simulation",
        description:
          "Implemented a multi-threaded client-server application in Java for simulating and controlling multiple robot clients. The architecture features a Swing-based GUI on both ends, enabling real-time interaction and visualization. Key functionalities include network communication via Robot objects, concurrent handling of multiple clients, dynamic GUI updates (robot positions, collision alerts, connection status), and client-side speed control with optional automatic updates.",
        technologies: [
          "Client-Server Architecture",
          "Real-time Control",
          "Object Serialization",
          "Multi-threading",
          "Event Handling",
          "Java Sockets",
          "Java GUI",
          "Java AWT Canvas",
          "Java Swing",
          "Automatic Updates",
        ],
        category: "Software Systems",
        media: [
          JavaPlaceholder,
          CSA1,
          CSA2,
          CSA3,
          CSA4,
          CSA5,
          CSA6,
          CSA7,
          CSA8,
          CSA9,
        ],
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/JavaClientServerApplication",
          },
        ],
      },
      {
        id: "human-activity-recognition-ml",
        slug: "human-activity-recognition-ml",
        name: "Human Activity Recognition - Data Analysis and ML",
        description:
          "Built a predictive model using supervised learning on sensor data from the Extrasensory dataset. Performed feature engineering, performance analysis, and model selection.",
        technologies: ["Python", "Jupyter Notebook", "Pandas", "NumPy", "ML"],
        media: [
          PythonPlaceholder,
          DAML1,
          DAML2,
          DAML3,
          DAML4,
          DAML5,
          DAML6,
          DAML7,
          DAML8,
        ],
        category: "Data Science / Machine Learning",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/GoogleCollab",
          },
          {
            type: "pdf",
            url: "https://github.com/Vishnusimha/GoogleCollab/blob/main/DA_ML%20for%20git.pdf",
          },
        ],
      },
      {
        id: "pipulse-ai-health-monitor",
        slug: "pipulse-ai-health-monitor",
        name: "PiPulse AI - Smart Raspberry Pi Health Monitor",
        description:
          "Built a smart Raspberry Pi health monitoring dashboard using Python, Flask, JavaScript, and systemd. The system monitors CPU temperature, CPU load, RAM usage, disk usage, uptime, IP address, and Raspberry Pi throttling or undervoltage status in real time. It includes a live browser dashboard, JSON API, live charts, auto-start after reboot, and a baseline AI anomaly detection layer that identifies abnormal system behavior and provides health recommendations.",
        technologies: [
          "Python",
          "Flask",
          "Raspberry Pi",
          "Linux",
          "JavaScript",
          "HTML",
          "CSS",
          "REST API",
          "systemd",
          "Edge Computing",
          "IoT Monitoring",
          "Artificial Intelligence",
          "Anomaly Detection",
          "Rule-Based AI",
          "GitHub",
        ],
        media: [PiPulse1Optimized, PiPulse2Optimized],
        category: "IoT",
        categories: ["IoT", "Data Science / Machine Learning"],
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/pipulse",
          },
        ],
      },
      {
        id: "aes-present-encryption-algorithms",
        slug: "aes-present-encryption-algorithms",
        name: "AES-128 and PRESENT-80 Encryption-Algorithms - Academic Project",
        description:
          "Implemented AES-128 and PRESENT-80 cipher encryption in C++, ensuring adherence to specified key and block sizes. Validated implementation through ECB mode test encryptions and provided a concise comparison between the two algorithms.",
        technologies: [
          "C++",
          "Python",
          "Encryption Software",
          "Object-Oriented Programming (OOP)",
          "Software Design",
        ],
        // TODO : Add AES-128 and PRESENT-80 images
        media: [CppPlaceholder, PythonPlaceholder],
        category: "Software Systems",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/AES-Encryption-Algorithm",
          },
          {
            type: "pdf",
            url: "https://github.com/Vishnusimha/Present80-Encryption-Algorithm",
          },
        ],
      },
      {
        id: "cpp-design-challenge",
        slug: "cpp-design-challenge",
        name: "C++ Design Challenge - Academic Project",
        description:
          "Designed and implemented a robust C++ security system with keypad, fingerprint, and hybrid locks for flexible authentication. Proficiently applied OOP principles like inheritance, polymorphism, and dynamic memory management. Showcased expertise in container classes and algorithms for efficient data manipulation. Overall, demonstrated strong capabilities in software design and implementation.",
        technologies: [
          "C++",
          "Object-Oriented Programming (OOP)",
          "Software Design",
        ],
        // TODO :C++ Design Challenge images
        media: [CppPlaceholder],
        category: "Software Systems",
        links: [
          {
            type: "github",
            url: "https://github.com/Vishnusimha/CppDesignChallange",
          },
          {
            type: "pdf",
            url: "https://github.com/Vishnusimha/CppDesignChallange/blob/main/C%2B%2B%20Design%20challenge%20code%20Documentation%20GIT.pdf",
          },
        ],
      },
    ],
    [],
  );

  const [currentMediaIndex, setCurrentMediaIndex] = useState(
    Array(projects.length).fill(0),
  );

  // State to manage the active category filter, null means "All"
  const [activeCategory, setActiveCategory] = useState(null);
  const [copiedProjectId, setCopiedProjectId] = useState(null);
  const [highlightedProjectId, setHighlightedProjectId] = useState(null);

  // State to track which project descriptions are expanded
  const [expandedDescriptions, setExpandedDescriptions] = useState(new Set());

  // Refs and state to detect which descriptions overflow the collapsed line clamp
  const descriptionRefs = useRef({});
  const [longDescriptions, setLongDescriptions] = useState(new Set());

  const toggleDescription = useCallback((projectId) => {
    setExpandedDescriptions((prev) => {
      const next = new Set(prev);
      if (next.has(projectId)) {
        next.delete(projectId);
      } else {
        next.add(projectId);
      }
      return next;
    });
  }, []);

  // Auto-carousel states
  const [isAutoPlaying, setIsAutoPlaying] = useState(
    Array(projects.length).fill(true),
  );
  const intervalRefs = useRef(Array(projects.length).fill(null));
  const [userPausedProjects, setUserPausedProjects] = useState(
    Array(projects.length).fill(false),
  );
  const [visibleProjectIds, setVisibleProjectIds] = useState(new Set());
  const projectCardRefs = useRef({});
  const copiedFeedbackTimeoutRef = useRef(null);
  const highlightTimeoutRef = useRef(null);
  const focusedProjectRouteRef = useRef("");

  // Lightbox/Modal states
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxProject, setLightboxProject] = useState(null);
  const [lightboxImageIndex, setLightboxImageIndex] = useState(0);
  const [lightboxZoomed, setLightboxZoomed] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Ref for lightbox container to avoid DOM queries
  const lightboxContainerRef = useRef(null);

  // Get unique categories from the projects data
  const categories = Array.from(
    new Set(
      projects.flatMap((project) => getProjectCategories(project)),
    ),
  );

  // Create a mapping of project IDs to their indices for better performance
  const projectIndexMap = useMemo(() => {
    const map = new Map();
    projects.forEach((project, index) => {
      map.set(project.id, index);
    });
    return map;
  }, [projects]);

  useEffect(() => {
    if (!categorySlug || categorySlug === PROJECT_CATEGORY_SLUGS.All) {
      setActiveCategory(null);
      return;
    }

    const category = getCategoryFromSlug(categorySlug);
    if (!category) {
      navigate("/projects", { replace: true });
      return;
    }

    setActiveCategory(category);
  }, [categorySlug, navigate]);

  // Auto-carousel functionality
  const startAutoPlay = useCallback(
    (projectIndex) => {
      if (projects[projectIndex].media.length <= 1) return;

      if (intervalRefs.current[projectIndex]) {
        clearInterval(intervalRefs.current[projectIndex]);
      }

      const intervalId = setInterval(() => {
        setCurrentMediaIndex((prevIndexes) =>
          prevIndexes.map((index, i) =>
            i === projectIndex
              ? (index + 1) % projects[projectIndex].media.length
              : index,
          ),
        );
      }, 3000); // Change slide every 3 seconds

      intervalRefs.current[projectIndex] = intervalId;

      setIsAutoPlaying((prev) =>
        prev[projectIndex]
          ? prev
          : prev.map((playing, i) => (i === projectIndex ? true : playing)),
      );

      setUserPausedProjects((prev) =>
        prev[projectIndex]
          ? prev.map((paused, i) => (i === projectIndex ? false : paused))
          : prev,
      );
    },
    [projects],
  );

  const stopAutoPlay = (projectIndex) => {
    if (intervalRefs.current[projectIndex]) {
      clearInterval(intervalRefs.current[projectIndex]);
      intervalRefs.current[projectIndex] = null;
    }
    setIsAutoPlaying((prev) =>
      prev[projectIndex]
        ? prev.map((playing, i) => (i === projectIndex ? false : playing))
        : prev,
    );
    setUserPausedProjects((prev) =>
      prev[projectIndex]
        ? prev
        : prev.map((paused, i) => (i === projectIndex ? true : paused)),
    );
  };

  const toggleAutoPlay = (projectIndex) => {
    if (isAutoPlaying[projectIndex]) {
      stopAutoPlay(projectIndex);
    } else {
      startAutoPlay(projectIndex);
    }
  };

  // Lightbox/Modal functions
  const openLightbox = (projectIndex, imageIndex) => {
    setLightboxProject(projects[projectIndex]);
    setLightboxImageIndex(imageIndex);
    setLightboxOpen(true);
    setLightboxZoomed(false);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxProject(null);
    setLightboxImageIndex(0);
    setLightboxZoomed(false);
    setIsFullScreen(false);
    // Exit fullscreen if currently in fullscreen mode
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const nextLightboxImage = useCallback(() => {
    if (
      lightboxProject &&
      lightboxImageIndex < lightboxProject.media.length - 1
    ) {
      setLightboxImageIndex((prev) => prev + 1);
      setLightboxZoomed(false);
    }
  }, [lightboxProject, lightboxImageIndex]);

  const prevLightboxImage = useCallback(() => {
    if (lightboxProject && lightboxImageIndex > 0) {
      setLightboxImageIndex((prev) => prev - 1);
      setLightboxZoomed(false);
    }
  }, [lightboxProject, lightboxImageIndex]);

  const toggleLightboxZoom = useCallback(() => {
    setLightboxZoomed((prev) => !prev);
  }, []);

  const toggleFullScreen = async () => {
    if (!document.fullscreenElement) {
      // Enter fullscreen
      const lightboxContainer = lightboxContainerRef.current;
      if (lightboxContainer && lightboxContainer.requestFullscreen) {
        try {
          await lightboxContainer.requestFullscreen();
          setIsFullScreen(true);
        } catch (err) {
          console.error("Error entering fullscreen:", err);
        }
      }
    } else {
      // Exit fullscreen
      try {
        await document.exitFullscreen();
        setIsFullScreen(false);
      } catch (err) {
        console.error("Error exiting fullscreen:", err);
      }
    }
  };

  // Keyboard navigation for lightbox
  const handleKeyDown = useCallback(
    (e) => {
      if (!lightboxOpen) return;

      switch (e.key) {
        case "Escape":
          closeLightbox();
          break;
        case "ArrowLeft":
          prevLightboxImage();
          break;
        case "ArrowRight":
          nextLightboxImage();
          break;
        case "z":
        case "Z":
          toggleLightboxZoom();
          break;
        case "f":
        case "F":
          toggleFullScreen();
          break;
        default:
          break;
      }
    },
    [lightboxOpen, nextLightboxImage, prevLightboxImage, toggleLightboxZoom],
  );

  // Focus trap for lightbox accessibility
  useEffect(() => {
    if (lightboxOpen && lightboxContainerRef.current) {
      const container = lightboxContainerRef.current;
      const focusableElements = container.querySelectorAll(
        'button, [href], [tabindex]:not([tabindex="-1"])',
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleTabKey = (e) => {
        if (e.key === "Tab") {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              lastElement.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastElement) {
              firstElement.focus();
              e.preventDefault();
            }
          }
        }
      };

      // Focus the first element when lightbox opens
      if (firstElement) {
        firstElement.focus();
      }

      document.addEventListener("keydown", handleTabKey);
      return () => document.removeEventListener("keydown", handleTabKey);
    }
  }, [lightboxOpen]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  // Handle fullscreen change events
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  useEffect(() => {
    return () => {
      if (copiedFeedbackTimeoutRef.current) {
        window.clearTimeout(copiedFeedbackTimeoutRef.current);
      }
      if (highlightTimeoutRef.current) {
        window.clearTimeout(highlightTimeoutRef.current);
      }
    };
  }, []);

  // Sync array lengths with projects count to handle dynamic project changes
  useEffect(() => {
    const projectCount = projects.length;

    // Update state arrays if project count has changed
    setCurrentMediaIndex((prev) => {
      if (prev.length !== projectCount) {
        return Array(projectCount).fill(0);
      }
      return prev;
    });

    setIsAutoPlaying((prev) => {
      if (prev.length !== projectCount) {
        return Array(projectCount).fill(true);
      }
      return prev;
    });

    setUserPausedProjects((prev) => {
      if (prev.length !== projectCount) {
        return Array(projectCount).fill(false);
      }
      return prev;
    });

    // Reset interval refs array if length changed
    if (intervalRefs.current.length !== projectCount) {
      // Clear existing intervals
      intervalRefs.current.forEach((intervalId) => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      });
      intervalRefs.current = Array(projectCount).fill(null);
    }
  }, [projects.length]);

  // Filter projects based on the active category
  const filteredProjects = useMemo(() => {
    return activeCategory
      ? projects.filter((project) =>
          getProjectCategories(project).includes(activeCategory),
        )
      : projects;
  }, [activeCategory, projects]);

  const deepLinkedProject = useMemo(() => {
    if (!projectSlug) {
      return null;
    }

    return (
      filteredProjects.find((project) => project.slug === projectSlug) || null
    );
  }, [filteredProjects, projectSlug]);

  const renderedProjectIds = useMemo(
    () => new Set(filteredProjects.map((project) => project.id)),
    [filteredProjects],
  );

  useEffect(() => {
    if (!projectSlug || !deepLinkedProject) {
      return undefined;
    }

    const routeKey = `${location.pathname}:${deepLinkedProject.id}`;
    if (focusedProjectRouteRef.current === routeKey) {
      return undefined;
    }

    focusedProjectRouteRef.current = routeKey;

    setHighlightedProjectId(deepLinkedProject.id);

    if (highlightTimeoutRef.current) {
      window.clearTimeout(highlightTimeoutRef.current);
    }

    highlightTimeoutRef.current = window.setTimeout(() => {
      setHighlightedProjectId(null);
    }, PROJECT_HIGHLIGHT_DURATION_MS);

    const scrollTimeoutId = window.setTimeout(() => {
      const card = projectCardRefs.current[deepLinkedProject.id];
      if (!card) {
        return;
      }

      card.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);

    return () => {
      window.clearTimeout(scrollTimeoutId);
    };
  }, [deepLinkedProject, location.pathname, projectSlug]);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      setVisibleProjectIds(new Set(filteredProjects.map((project) => project.id)));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        setVisibleProjectIds((prev) => {
          const next = new Set(prev);
          entries.forEach((entry) => {
            const projectId = entry.target.dataset.projectId;
            if (!projectId) {
              return;
            }

            if (entry.isIntersecting) {
              next.add(projectId);
            } else {
              next.delete(projectId);
            }
          });
          return next;
        });
      },
      {
        rootMargin: PROJECT_MEDIA_PRELOAD_MARGIN,
        threshold: 0.01,
      },
    );

    filteredProjects.forEach((project) => {
      const card = projectCardRefs.current[project.id];
      if (card) {
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, [filteredProjects]);

  const updateLongDescriptions = useCallback(() => {
    const longSet = new Set();
    filteredProjects.forEach((project) => {
      const el = descriptionRefs.current[project.id];
      if (!el) {
        return;
      }

      const styles = window.getComputedStyle(el);
      const fontSize = parseFloat(styles.fontSize);
      let lineHeight = parseFloat(styles.lineHeight);
      if (styles.lineHeight === "normal") {
        lineHeight = fontSize * 1.2;
      } else if (!styles.lineHeight.endsWith("px")) {
        lineHeight *= fontSize;
      }

      const collapsedHeight = lineHeight * DESCRIPTION_COLLAPSED_LINES;
      if (el.scrollHeight > collapsedHeight + 1) {
        longSet.add(project.id);
      }
    });
    setLongDescriptions(longSet);
  }, [filteredProjects]);

  // Detect which descriptions need the expand control.
  useEffect(() => {
    updateLongDescriptions();

    const resizeObserver = new ResizeObserver(updateLongDescriptions);
    filteredProjects.forEach((project) => {
      const el = descriptionRefs.current[project.id];
      if (el) {
        resizeObserver.observe(el);
      }
    });

    return () => resizeObserver.disconnect();
  }, [filteredProjects, updateLongDescriptions]);

  // Start auto-play only for projects that are close enough to be viewed.
  useEffect(() => {
    projects.forEach((project, index) => {
      if (
        renderedProjectIds.has(project.id) &&
        visibleProjectIds.has(project.id) &&
        project.media.length > 1 &&
        !userPausedProjects[index]
      ) {
        startAutoPlay(index);
      } else if (intervalRefs.current[index]) {
        clearInterval(intervalRefs.current[index]);
        intervalRefs.current[index] = null;
        setIsAutoPlaying((prev) =>
          prev.map((playing, i) => (i === index ? false : playing)),
        );
      }
    });

    // Cleanup intervals on unmount
    return () => {
      intervalRefs.current.forEach((intervalId) => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      });
    };
  }, [
    projects,
    renderedProjectIds,
    startAutoPlay,
    userPausedProjects,
    visibleProjectIds,
  ]);

  const getCategoryIcons = useCallback((category) => {
    switch (category) {
      case "Mobile Development":
        return (
          <>
            <FaMobileAlt className="inline-icon" />
          </>
        );
      case "IoT":
        return (
          <>
            <FiCpu className="inline-icon" />
            <FiActivity className="inline-icon" />
            <FiGlobe className="inline-icon" />
            <FaMobileAlt className="inline-icon" />
          </>
        );
      case "Full-Stack Development":
        return (
          <>
            <FiGlobe className="inline-icon" />
            <FaCodeBranch className="inline-icon" />
            <FaCloud className="inline-icon" />
            <FiDatabase className="inline-icon" />
            <FiServer className="inline-icon" />
          </>
        );
      case "Web Development":
        return (
          <>
            <FiGlobe className="inline-icon" />
            <FaCloud className="inline-icon" />
          </>
        );
      case "Data Science / Machine Learning":
        return (
          <>
            <FaBrain className="inline-icon" />
            <GoDatabase className="inline-icon" />
            <GiArtificialIntelligence className="inline-icon" />
            <FaChartBar className="inline-icon" />
            <AiOutlineLineChart className="inline-icon" />
            <BsBarChartLine className="inline-icon" />
          </>
        );
      case "Software Systems":
        return (
          <>
            <FiCpu className="inline-icon" />
            <FiServer className="inline-icon" />
            <FaCodeBranch className="inline-icon" />
          </>
        );
      default:
        return <FiCpu className="inline-icon" />;
    }
  }, []);

  const handleNextMedia = (projectIndex) => {
    // Stop auto-play when user interacts and mark as manually paused
    stopAutoPlay(projectIndex);

    setCurrentMediaIndex((prevIndexes) =>
      prevIndexes.map((index, i) =>
        i === projectIndex
          ? (index + 1) % projects[projectIndex].media.length
          : index,
      ),
    );
  };

  const handlePrevMedia = (projectIndex) => {
    // Stop auto-play when user interacts and mark as manually paused
    stopAutoPlay(projectIndex);

    setCurrentMediaIndex((prevIndexes) =>
      prevIndexes.map((index, i) =>
        i === projectIndex
          ? index === 0
            ? projects[projectIndex].media.length - 1
            : index - 1
          : index,
      ),
    );
  };

  const handleThumbnailClick = (projectIndex, mediaIndex) => {
    // Stop auto-play when user interacts and mark as manually paused
    stopAutoPlay(projectIndex);

    setCurrentMediaIndex((prevIndexes) =>
      prevIndexes.map((index, i) => (i === projectIndex ? mediaIndex : index)),
    );
  };

  const handleCategorySelect = (category) => {
    navigate(`/projects/${getCategorySlug(category)}`);
  };

  const handleShareProject = async (event, project) => {
    event.stopPropagation();

    const url = getAbsoluteProjectUrl(project);
    const shareData = {
      title: project.name,
      text: project.description,
      url,
    };

    let copiedToClipboard = false;

    try {
      if (window.navigator?.share) {
        try {
          await window.navigator.share(shareData);
        } catch (shareError) {
          if (shareError.name === "AbortError") {
            return;
          }

          await copyTextToClipboard(url);
          copiedToClipboard = true;
        }
      } else {
        await copyTextToClipboard(url);
        copiedToClipboard = true;
      }

      if (copiedToClipboard) {
        setCopiedProjectId(project.id);
        if (copiedFeedbackTimeoutRef.current) {
          window.clearTimeout(copiedFeedbackTimeoutRef.current);
        }
        copiedFeedbackTimeoutRef.current = window.setTimeout(() => {
          setCopiedProjectId(null);
        }, SHARE_FEEDBACK_DURATION_MS);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Unable to share project link:", error);
      }
    }
  };

  return (
    <section ref={ref} className="projects-section" id="projects">
      <div className="projects-header">
        <h2 className="projects-title">Projects</h2>
        <div className="projects-divider"></div>
      </div>

      {/* Category Filter Buttons */}
      <div className="category-filters">
        <button
          className={`filter-button ${activeCategory === null ? "active" : ""}`}
          onClick={() => handleCategorySelect("All")}
        >
          All
        </button>
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-button ${
              activeCategory === category ? "active" : ""
            }`}
            onClick={() => handleCategorySelect(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="projects-container">
        {filteredProjects.map((project, index) => {
          const projectIndex = projectIndexMap.get(project.id);
          const isFirstVisibleProject = index === 0;
          return (
            <div
              key={project.name}
              className={`project-card ${
                highlightedProjectId === project.id
                  ? "project-card-highlight"
                  : ""
              }`}
              data-project-id={project.id}
              ref={(el) => {
                projectCardRefs.current[project.id] = el;
              }}
            >
              <div className="project-card-inner">
                <div className="project-media-container">
                  <div className="project-media-wrapper">
                    <img
                      src={getMediaThumbnailSrc(
                        project.media[currentMediaIndex[projectIndex]],
                      )}
                      alt={`${project.name} screenshot ${
                        currentMediaIndex[projectIndex] + 1
                      }`}
                      className="project-media"
                      loading={isFirstVisibleProject ? "eager" : "lazy"}
                      decoding="async"
                      onClick={() =>
                        openLightbox(
                          projectIndex,
                          currentMediaIndex[projectIndex],
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>

                  <button
                    type="button"
                    className="project-share-button"
                    onClick={(event) => handleShareProject(event, project)}
                    aria-label={`Share ${project.name}`}
                    title="Share project"
                  >
                    <FiShare2 aria-hidden="true" />
                  </button>
                  {copiedProjectId === project.id && (
                    <span className="project-share-copied" role="status">
                      Link copied
                    </span>
                  )}

                  <div className="media-controls">
                    <button
                      onClick={() => toggleAutoPlay(projectIndex)}
                      className="media-control-button auto-play-toggle"
                      aria-label={
                        isAutoPlaying[projectIndex]
                          ? "Pause slideshow"
                          : "Play slideshow"
                      }
                      title={
                        isAutoPlaying[projectIndex]
                          ? "Pause slideshow"
                          : "Play slideshow"
                      }
                    >
                      {isAutoPlaying[projectIndex] ? <FiPause /> : <FiPlay />}
                    </button>

                    <button
                      onClick={() => handlePrevMedia(projectIndex)}
                      className="media-control-button"
                      aria-label="Previous image"
                    >
                      <FiChevronLeft />
                    </button>
                    <button
                      onClick={() => handleNextMedia(projectIndex)}
                      className="media-control-button"
                      aria-label="Next image"
                    >
                      <FiChevronRight />
                    </button>
                  </div>

                  {project.media.length > 1 && (
                    <div className="media-thumbnails">
                      {project.media.slice(0, 3).map((media, mediaIndex) => (
                        <button
                          key={mediaIndex}
                          onClick={() =>
                            handleThumbnailClick(projectIndex, mediaIndex)
                          }
                          className={`thumbnail ${
                            currentMediaIndex[projectIndex] === mediaIndex
                              ? "active"
                              : ""
                          }`}
                          aria-label={`View image ${mediaIndex + 1}`}
                        >
                          <img
                            src={getMediaThumbnailSrc(media)}
                            alt=""
                            role="presentation"
                            loading="lazy"
                            decoding="async"
                          />
                        </button>
                      ))}
                      {project.media.length > 3 && (
                        <span className="thumbnail-count">
                          +{project.media.length - 3}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <div className="project-content">
                  <div className="project-header">
                    <span className="project-category">
                      {getProjectCategories(project).map((category) => (
                        <span className="project-category-item" key={category}>
                          {getCategoryIcons(category)} {category}
                        </span>
                      ))}
                    </span>
                    <h3 className="project-title">{project.name}</h3>
                  </div>

                  <div className="project-description-wrapper">
                    <p
                      ref={(el) => {
                        descriptionRefs.current[project.id] = el;
                      }}
                      className={`project-description ${
                        expandedDescriptions.has(project.id)
                          ? "expanded"
                          : "collapsed"
                      }`}
                    >
                      {project.description}
                    </p>
                    {longDescriptions.has(project.id) && (
                      <button
                        className="description-toggle"
                        onClick={() => toggleDescription(project.id)}
                        aria-expanded={expandedDescriptions.has(project.id)}
                      >
                        {expandedDescriptions.has(project.id)
                          ? "Show less ▲"
                          : "Show more ▼"}
                      </button>
                    )}
                  </div>

                  <div className="project-technologies">
                    {project.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                  <div className="project-links">
                    {project.links?.map((link, linkIndex) => (
                      <a
                        key={linkIndex}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`project-link ${link.type}`}
                      >
                        {link.type === "github" ? (
                          <>
                            <FiGithub /> View Code
                          </>
                        ) : link.type === "demo" ? (
                          <>
                            <FiExternalLink /> Live Demo
                          </>
                        ) : link.type === "pdf" ? (
                          <>
                            <FiExternalLink /> View Document
                          </>
                        ) : link.type === "playstore" ? (
                          <>
                            <FaGooglePlay /> Play Store
                          </>
                        ) : null}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Lightbox/Modal */}
      {lightboxOpen && lightboxProject && (
        <div
          className="lightbox-overlay"
          onClick={(e) => {
            // Only close if clicking directly on overlay, not on modal content
            if (e.target === e.currentTarget) {
              closeLightbox();
            }
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="lightbox-title"
          aria-describedby="lightbox-instructions"
        >
          <div
            ref={lightboxContainerRef}
            className="lightbox-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="lightbox-header">
              <h3 id="lightbox-title" className="lightbox-title">
                {lightboxProject.name}
              </h3>
              <div className="lightbox-controls">
                <button
                  className="lightbox-control-btn"
                  onClick={toggleLightboxZoom}
                  title={lightboxZoomed ? "Zoom out" : "Zoom in"}
                  aria-label={lightboxZoomed ? "Zoom out" : "Zoom in"}
                >
                  {lightboxZoomed ? <FiMaximize2 /> : <FiZoomIn />}
                </button>
                <button
                  className="lightbox-control-btn"
                  onClick={toggleFullScreen}
                  title={isFullScreen ? "Exit fullscreen" : "Enter fullscreen"}
                  aria-label={
                    isFullScreen ? "Exit fullscreen" : "Enter fullscreen"
                  }
                >
                  {isFullScreen ? <FiMinimize2 /> : <FiMaximize2 />}
                </button>
                <button
                  className="lightbox-control-btn"
                  onClick={closeLightbox}
                  title="Close"
                  aria-label="Close lightbox"
                >
                  <FiX />
                </button>
              </div>
            </div>

            <div className="lightbox-content">
              <div className="lightbox-image-container">
                {lightboxImageIndex > 0 && (
                  <button
                    className="lightbox-nav-btn lightbox-nav-prev"
                    onClick={prevLightboxImage}
                    title="Previous image"
                    aria-label="Previous image"
                  >
                    <FiChevronLeft />
                  </button>
                )}

                <img
                  src={getMediaSrc(lightboxProject.media[lightboxImageIndex])}
                  alt={`${lightboxProject.name} screenshot ${
                    lightboxImageIndex + 1
                  }`}
                  decoding="async"
                  className={`lightbox-image ${lightboxZoomed ? "zoomed" : ""}`}
                />

                {lightboxImageIndex < lightboxProject.media.length - 1 && (
                  <button
                    className="lightbox-nav-btn lightbox-nav-next"
                    onClick={nextLightboxImage}
                    title="Next image"
                    aria-label="Next image"
                  >
                    <FiChevronRight />
                  </button>
                )}
              </div>

              <div className="lightbox-info">
                <div className="lightbox-image-counter">
                  {lightboxImageIndex + 1} / {lightboxProject.media.length}
                </div>
                <div
                  id="lightbox-instructions"
                  className="lightbox-instructions"
                >
                  Use arrow keys to navigate • Press ESC to close • Press Z to
                  zoom • Press F for fullscreen
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
});

export default Projects;
